import React from "react";
import { Link } from "@quintype/components";
import { RightArrowIcon } from "../../../../assets/icons/RightArrowIcon";
import GlobalSectionLink from "../../atoms/SectionLink";
import "./ceo-forum.m.css";

export const SectionLink = ({ text, href }) => {
  return <GlobalSectionLink href={href}>{text}</GlobalSectionLink>;
};

export const ColumnBlock = ({ title, items = [], variant, hasTitle = true }) => {
  const headerClass = variant === "tint" ? "column-header-tint" : "column-header-dark";
  const itemsClass = variant === "tint" ? "column-items-tint" : "column-items";

  return (
    <div styleName="column-block">
      <div styleName={`column-header ${headerClass}`}>
        <div styleName="column-title" dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <div styleName={`column-items ${itemsClass}`}>
        {items.map(({ title: itemTitle, description }, idx) => {
          const contentToShow = description || itemTitle || "";
          return (
            <div key={idx} styleName="column-item">
              {hasTitle && itemTitle && <div styleName="item-title" dangerouslySetInnerHTML={{ __html: itemTitle }} />}
              <div styleName="item-description" dangerouslySetInnerHTML={{ __html: hasTitle ? description : contentToShow }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const EventCard = ({ title, duration, location }) => (
  <div styleName="event-card">
    <div styleName="event-title" dangerouslySetInnerHTML={{ __html: title }} />
    <div styleName="event-info" dangerouslySetInnerHTML={{ __html: duration }} />
    <div styleName="event-info" dangerouslySetInnerHTML={{ __html: location }} />
  </div>
);